export function InvalidSVG({ show = false }) {
  return show ? (
    <svg className="invalid-strike">
      <line x1="100%" y1="100%" x2="0" y2="0"></line>
    </svg>
  ) : (
    <></>
  );
}
